export function isValidPesel(input?: string | null): boolean {
  if (!input) return false;

  const pesel = input.replace(/\D/g, "");
  if (pesel.length !== 11) return false;

  const digits = pesel.split("").map(Number);
  const year = parseInt(pesel.substring(0, 2), 10);

  let month = parseInt(pesel.substring(2, 4), 10);
  let century = 1900;
  if (month >= 81 && month <= 92) { century = 1800; month -= 80; }
  else if (month >= 1 && month <= 12) { century = 1900; }
  else if (month >= 21 && month <= 32) { century = 2000; month -= 20; }
  else if (month >= 41 && month <= 52) { century = 2100; month -= 40; }
  else if (month >= 61 && month <= 72) { century = 2200; month -= 60; }
  else { return false; }

  const fullYear = century + year;
  const day = parseInt(pesel.substring(4, 6), 10);

  const date = new Date(fullYear, month - 1, day);
  if (
    date.getFullYear() !== fullYear ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }

  const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const sum =
    weights.reduce((acc, w, i) => acc + w * digits[i], 0) % 10;
  const control = (10 - sum) % 10;

  return control === digits[10];
}